// extracted by mini-css-extract-plugin
module.exports = {"card":"ChannelCard_card__OIgXl","icon":"ChannelCard_icon__x9vdn"};